/* nb-cmax-question-panels.js
   Delegated on document, same pattern as nb-ui's own `ask` module. The buy section's
   question pills (2026-09-26) now carry the nb-ui sheet/drawer open attributes directly
   (data-nb-sheet-open="nb-question-sheet" on the phone trigger, data-nb-drawer-open="nb-question-drawer"
   on the desktop trigger, per NB-UI.md's two-physical-trigger rule), so nb-ui itself opens the
   panel. All this script does is set which of the three question panels is visible inside
   the sheet/drawer: any click on [data-nb-qpanel-switch="key"] anywhere on the page (the pills
   themselves, and the "switch to a different question" pills inside an already-open panel)
   shows the matching [data-nb-qpanel="key"] content and hides the other two. Retired
   2026-09-26: the old KEY_MAP + proxy-click bridge that used to open the sheet/drawer for
   pills that could not carry nb-ui attributes directly.
*/
(function () {
  function setActive(key) {
    document.querySelectorAll('[data-nb-qpanel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-nb-qpanel') !== key;
    });
  }

  document.addEventListener('click', function (event) {
    var switcher = event.target.closest('[data-nb-qpanel-switch]');
    if (switcher) {
      setActive(switcher.getAttribute('data-nb-qpanel-switch'));
    }
  });
})();
